export const REORDER_RAIL_CARD_PLACEHOLDER_SIZE_XS = 222;
export const REORDER_RAIL_CARD_PLACEHOLDER_SIZE_MD = 322;

export const REORDER_RAIL_CARD_SIZE_XS = 152;
export const REORDER_RAIL_CARD_SIZE_LG = 240;
